// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2445":"15a12f3b","3923":"dff03057"}[chunkId] + ".css";
};